import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["backdrop", "panel"]

  connect() {
    this._handleKeydown = (event) => {
      if (event.key === "Escape") {
        this.close()
        return
      }
      if (event.key !== "Tab") return

      const controls = [...this.panelTarget.querySelectorAll("a[href], button, input, select, textarea, summary, [tabindex='0']")]
        .filter(element => !element.disabled && element.getClientRects().length)
      if (!controls.length) {
        event.preventDefault()
        this.panelTarget.focus()
        return
      }
      const first = controls[0], last = controls[controls.length - 1]
      if (event.shiftKey && (document.activeElement === first || document.activeElement === this.panelTarget)) {
        event.preventDefault()
        last.focus()
      } else if (!event.shiftKey && (document.activeElement === last || document.activeElement === this.panelTarget)) {
        event.preventDefault()
        first.focus()
      }
    }
    this._keepFocusInside = (event) => {
      if (!this.panelTarget.contains(event.target)) this.panelTarget.focus()
    }
  }

  open(event) {
    event?.preventDefault()
    this.previouslyFocusedElement = document.activeElement
    this.backdropTarget.classList.remove("hidden")
    this.backdropTarget.removeAttribute("aria-hidden")
    document.documentElement.classList.add("overflow-hidden")
    document.body.classList.add("overflow-hidden")
    document.addEventListener("keydown", this._handleKeydown)
    document.addEventListener("focusin", this._keepFocusInside)
    requestAnimationFrame(() => this.panelTarget.focus())
  }

  close() {
    if (!this.hasBackdropTarget) return

    this.backdropTarget.classList.add("hidden")
    this.backdropTarget.setAttribute("aria-hidden", "true")
    document.documentElement.classList.remove("overflow-hidden")
    document.body.classList.remove("overflow-hidden")
    document.removeEventListener("keydown", this._handleKeydown)
    document.removeEventListener("focusin", this._keepFocusInside)

    if (this.previouslyFocusedElement?.focus) {
      this.previouslyFocusedElement.focus()
    }
  }

  backdropClose(event) {
    if (event.target === this.backdropTarget) this.close()
  }

  disconnect() {
    if (this.hasBackdropTarget) {
      this.backdropTarget.classList.add("hidden")
      this.backdropTarget.setAttribute("aria-hidden", "true")
    }

    document.documentElement.classList.remove("overflow-hidden")
    document.body.classList.remove("overflow-hidden")
    document.removeEventListener("keydown", this._handleKeydown)
    document.removeEventListener("focusin", this._keepFocusInside)
  }
}
